const regDuration = /^((\d+:)?([0-5]?\d:)|([0-5]?\d:)?)[0-5]?\d$/;

class DateHelper {
  /**
   * 格式化月日，如：1->01
   * @param {Number} n
   */
  static formatDateNumber(n: number): string {
    return n < 10 ? "0" + n : n.toString();
  }

  /**
   * 移除 getTimestamp()方法
   *
   * 直接使用+new Date();
   */

  /**
   *  显示星期
   * @params dateOrTimestamp 时间戳或日期对象
   * @returns String  星期
   */
  static getDayOfWeek(dateOrTimestamp: Date | number | string): string {
    let date: Date;
    if (dateOrTimestamp instanceof Date) {
      date = dateOrTimestamp;
    } else {
      if (!/^-?\d+$/.test(dateOrTimestamp.toString())) {
        console.error("时间格式化失败，参数dateOrStamp错误：", dateOrTimestamp);
        return "时间错误";
      }

      date = new Date(parseInt(dateOrTimestamp.toString()));
    }

    const day = date.getDay();
    const weekArr = ["日", "一", "二", "三", "四", "五", "六"];

    return weekArr[day];
  }

  /**
   * 格式化时间戳（通用）
   * @param {*} dateOrTimestamp 时间戳 或 日期实例
   * @param {String} format 格式化
   * @param {Boolean} isMomentAgo 是否需要显示为 刚刚、xx分钟前、xx小时前（小于6小时）、今天 HH:mm:ss(格式化根据定义显示)
   * @param {Boolean} isThisYearNotShow 是否不需要显示当前年
   * @returns {'yyyy-MM-dd HH:mm:ss'} 返回对应格式数据
   */
  static formatTime(dateOrTimestamp: Date | number | string, format: string = "yyyy-MM-dd HH:mm:ss", isMomentAgo: boolean = false, isThisYearNotShow: boolean = false): string {
    let date: Date;
    if (dateOrTimestamp instanceof Date) {
      date = dateOrTimestamp;
    } else {
      if (!/^-?\d+$/.test(dateOrTimestamp.toString())) {
        console.error("时间格式化失败，参数dateOrStamp错误：", dateOrTimestamp);
        return "时间错误";
      }

      date = new Date(parseInt(dateOrTimestamp.toString()));
    }

    if (isThisYearNotShow && new Date().getFullYear() == date.getFullYear()) {
      let matchRes = format.match(/M.*/);
      if (matchRes && matchRes.length) {
        format = matchRes[0];
      }
    }

    let dict: Record<string, string | number> = {
      yyyy: date.getFullYear(),
      M: date.getMonth() + 1,
      d: date.getDate(),
      H: date.getHours(),
      m: date.getMinutes(),
      s: date.getSeconds(),
      S: ("" + (date.getMilliseconds() + 1000)).substring(1),
      MM: ("" + (date.getMonth() + 101)).substring(1),
      dd: ("" + (date.getDate() + 100)).substring(1),
      HH: ("" + (date.getHours() + 100)).substring(1),
      mm: ("" + (date.getMinutes() + 100)).substring(1),
      ss: ("" + (date.getSeconds() + 100)).substring(1),
    };

    if (isMomentAgo) {
      if (this.isToday(date)) {
        const diffMin = parseInt((+new Date() - +date) / 1000 / 60 + ""); //时间差（单位分钟）
        const diffHour = parseInt(diffMin / 60 + "");
        if (diffMin < 1) {
          return "刚刚";
        } else if (diffMin < 60) {
          return diffMin + "分钟前";
        } else if (diffHour < 6) {
          return diffHour + "小时前";
        } else {
          if (format.indexOf("H") > -1) {
            format = format.replace(/[\s\S].*?(?=H)/g, "");
          } else if (format.indexOf("m") > -1) {
            format = format.replace(/[\s\S].*?(?=m)/g, "");
          } else if (format.indexOf("s") > -1) {
            format = format.replace(/[\s\S].*?(?=s)/g, "");
          } else if (format.indexOf("S") > -1) {
            format = format.replace(/[\s\S].*?(?=S)/g, "");
          }

          if (format.indexOf("H") < 0 && format.indexOf("s") < 0 && format.indexOf("m") < 0 && format.indexOf("S") < 0) {
            format = ""; //当Hms都不存在的时候，移除 MM-dd的格式化
          }

          const result =
            "今天 " +
            format.replace(/(H+|s+|m+|S)/g, function (a) {
              return dict[a]?.toString() || "";
            });
          return result.trim();
        }
      } else if (this.isYesterday(date)) {
        if (format.indexOf("H") > -1) {
          format = format.replace(/[\s\S].*?(?=H)/g, "");
        } else if (format.indexOf("m") > -1) {
          format = format.replace(/[\s\S].*?(?=m)/g, "");
        } else if (format.indexOf("s") > -1) {
          format = format.replace(/[\s\S].*?(?=s)/g, "");
        } else if (format.indexOf("S") > -1) {
          format = format.replace(/[\s\S].*?(?=S)/g, "");
        }

        if (format.indexOf("H") < 0 && format.indexOf("s") < 0 && format.indexOf("m") < 0 && format.indexOf("S") < 0) {
          format = ""; //当Hms都不存在的时候，移除 MM-dd的格式化
        }

        const result =
          "昨天 " +
          format.replace(/(H+|s+|m+|S)/g, function (a) {
            return dict[a]?.toString() || "";
          });

        return result.trim();
      }
    }

    return format.replace(/(y+|M+|d+|H+|s+|m+|S)/g, function (a) {
      return dict[a]?.toString() || "";
    });
  }
  static formatDate(date: Date | number | string, format: string = "yyyy-MM-dd HH:mm:ss"): string {
    return this.formatTime(date, format);
  }
  static formatAgeTotalDays(date: Date, birthDate: Date): number {
    return this.formatTotalDays(date, birthDate) + 1; //总共天数 昨天出生，今天就是第二天
  }

  static formatTotalDays(date1: Date, date2: Date): number {
    date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    return parseInt(((date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24).toString()); //总共天数
  }

  /**
   * 获取月份差 (未满一个月，不算一个月) 1个月零xx天，为1个月
   * @param  出生时间 时间（单位：毫秒）
   * @param  目标时间 时间（单位：毫秒）
   * @returns {*} 月份差
   */
  static getMonthDiff(birthDate: Date, targetDate: Date): number {
    let monthInterval = (targetDate.getFullYear() - birthDate.getFullYear()) * 12 + (targetDate.getMonth() - birthDate.getMonth());
    if (targetDate.getDate() - birthDate.getDate() < 0) {
      monthInterval -= 1;
    }
    return monthInterval;
  }

  /**
   * 获取月份差 1月零xx天，为2月
   * @param  出生时间 时间（单位：毫秒）
   * @param  目标时间 时间（单位：毫秒）
   * @returns {*} 月份差
   */
  static getMonthUpperDiff(birthDate: Date, targetDate: Date): number {
    let monthInterval = (targetDate.getFullYear() - birthDate.getFullYear()) * 12 + (targetDate.getMonth() - birthDate.getMonth());
    if (targetDate.getDate() - birthDate.getDate() > 0) {
      monthInterval += 1;
    }
    return monthInterval;
  }

  /**
   * 解析出生日期
   */
  static formatAgeDate(birthDateStamp: number, targetTimestamp?: number, isSimpleText: boolean = false): string {
    let date: Date;
    if (!targetTimestamp) {
      date = new Date();
    } else {
      //转换日期
      date = new Date(targetTimestamp);
    }
    const dateArray = [date.getFullYear(), this.formatDateNumber(date.getMonth() + 1), date.getDate()];

    //获取出生时长
    const birthDate = new Date(birthDateStamp);
    const birthDateArray = [birthDate.getFullYear(), this.formatDateNumber(birthDate.getMonth() + 1), birthDate.getDate()];

    const days = this.formatAgeTotalDays(date, birthDate);
    if (days <= 100 && days > 0) {
      if (days == 100) {
        return isSimpleText ? "第100天啦" : "宝宝今天100天啦";
      }
      if (days == 30) {
        return isSimpleText ? "满月啦" : "宝宝今天满月啦";
      }
      if (days == 1) {
        return isSimpleText ? "刚出生" : "宝宝今天刚出生";
      }
      return "第" + days + "天";
    } else if (days <= 0) {
      return isSimpleText ? "出生前" : "宝宝出生前";
    }

    return this._formatBirthDateToString(birthDateArray, dateArray, isSimpleText);
  }

  /**
   * 将生日日期转换成时间间隔的描述
   * eg. 2015-12-21 => 1岁2个月
   */
  private static _formatBirthDateToString(birthDateArray: (string | number)[], currentDateArray: (string | number)[], isSimpleText: boolean): string {
    const age = this._getAge(Number(birthDateArray[0]), Number(birthDateArray[1]), Number(birthDateArray[2]), Number(currentDateArray[0]), Number(currentDateArray[1]), Number(currentDateArray[2]));

    if (age[1] == 0 && age[2] == 0) {
      return isSimpleText ? `${age[0]}岁生日` : `今天是宝宝${age[0]}岁生日`;
    }

    const year = age[0] < 1 ? "" : `${age[0]}岁`;
    const month = age[1] < 1 ? "" : `${age[1]}个月`;
    const day = age[2] < 1 ? "" : `${age[2]}天`;

    if (age[0] < 1 && age[2] < 1) {
      return age[1] + "个月"; //: '宝宝今天满' + age[1] + '个月啦';
    }

    return year + month + ((year.length < 1 || month.length < 1) && day ? "零" : "") + day;
  }

  /*
   * 参考：http://www.blogjava.net/luckwolf/archive/2012/01/12/368408.html
   * birthYear 出生年
   * birthMonth 出生月
   * birthDay 出生天
   * endCalcYear 计算截止日期年（今年）
   * endCalcMonth 计算截止日期月（月份从1开始，即1-12，本月）
   * endCalcDay 计算截止日期天（今天）
   * return Array [0]几岁 [1] 几月 [2] 几天
   */
  private static _getAge(birthYear: number, birthMonth: number, birthDay: number, endCalcYear: number, endCalcMonth: number, endCalcDay: number): [number, number, number] {
    // 生日
    const bDate = new Date();
    // 出生日加一天,《最高人民法院关于审理未成年人刑事案件具体应用法律若干问题的解释》第二条明确规定，“周岁”，按照公历的年月日计算，从周岁生日的第二天起算。
    // 之所以推迟一天计算，是出于人情上及尽量减少麻烦的考虑。
    bDate.setTime(bDate.getTime() + 1 * 24 * 60 * 60 * 1000);
    // 月份从0开始
    bDate.setFullYear(birthYear, birthMonth - 1, birthDay);
    // 计算截止日期
    const eDate = new Date();
    // 月份从0开始
    eDate.setFullYear(endCalcYear, endCalcMonth - 1, endCalcDay);
    // 天
    let day = eDate.getDate() - bDate.getDate();
    // 月
    let month = eDate.getMonth() - bDate.getMonth();
    // 年
    let year = eDate.getFullYear() - bDate.getFullYear();
    if (day < 0) {
      month -= 1;
      // 获取截至计算的月减去1
      let tempMonth = eDate.getMonth() - 1;
      // 获取截至计算的年
      let tempYear = eDate.getFullYear();
      // 如果月份是1（javascript:0）月份，那么年份就减1,月份设置成11，也就是上一年度的12月份
      if (tempMonth < 0) {
        tempYear -= 1;
        tempMonth = 11;
      }
      // 获取上一月的天数。
      let addDay = this.getDaysOfMonth(tempYear, tempMonth);
      day = day + addDay;
    }
    if (month < 0) {
      month = (month + 12) % 12;
      year--;
    }
    return [year, month, day];
  }

  /**
   * 获取指定月份的天数
   */
  static getDaysOfMonth(year: number, month: number): number {
    const days = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    // 平年28天
    if (!this.isLeapYear(year)) {
      days[1] = 28;
    }
    return days[month];
  }

  /**
   * 判断是否是闰年
   */
  static isLeapYear(year: number): boolean {
    if ((year % 4 == 0 && year % 100 != 0) || year % 100 == 0) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 判断是否当前月
   */
  static isCurrentMonth(date: Date): boolean {
    const todaysDate = new Date();
    return date.getFullYear() == todaysDate.getFullYear() && date.getMonth() == todaysDate.getMonth();
  }

  /**
   * 判断是否今天
   */
  static isToday(date: Date): boolean {
    const todaysDate = new Date();
    return date.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0);
  }

  /**
   * 判断是否昨天
   */
  static isYesterday(date: Date): boolean {
    const todaysDate = new Date();
    todaysDate.setDate(todaysDate.getDate() - 1);
    return date.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0);
  }

  /**
   * 判断是否前天
   */
  static isBeforeYesterday(date: Date): boolean {
    const todaysDate = new Date();
    todaysDate.setDate(todaysDate.getDate() - 2);
    return date.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0);
  }

  static getAgeYearMonthDayArray(birthdayStamp: number): [number, number, number] {
    const now = new Date();
    const birthDate = new Date(birthdayStamp);
    return this._getAge(birthDate.getFullYear(), birthDate.getMonth(), birthDate.getDate(), now.getFullYear(), now.getMonth(), now.getDate());
  }

  /**
   * 时长转换成秒
   * @returns Number
   */
  static durationToSeconds(duration: string): number | string {
    if (!regDuration.test(duration)) {
      console.error("时长转换成秒时,传入的时长格式错误,允许的格式为:20:59:59, 59:59, 59, 1:1:59, 1:59, 9 等(允许 时分秒位数 为个位数)");
      return "格式错误";
    }

    const arr = duration.split(":");
    const length = arr.length;
    let seconds;
    switch (length) {
      case 1:
        seconds = parseInt(arr[length - 1]);
        break;
      case 2:
        seconds = parseInt(arr[length - 2]) * 60 + parseInt(arr[length - 1]);
        break;
      case 3:
        seconds = parseInt(arr[length - 3]) * 60 * 60 + parseInt(arr[length - 2]) * 60 + parseInt(arr[length - 1]);
        break;

      default:
        seconds = duration;
        break;
    }
    console.log(`传入时长：${duration}，输出时长（单位s）：`, seconds);
    return seconds;
  }

  /**
   * 时长转换成区间段
   * @params duration 接受时长字符串或者非负数
   * @returns String
   */
  static durationToSection(duration: string | number): string {
    const unit = 60;
    let seconds: number;
    let section: string;
    if ("number" === typeof duration && duration >= 0) {
      seconds = duration;
    } else {
      const secResult = this.durationToSeconds(duration as string)
      if ("number" !== typeof seconds && seconds < 0) {
        console.error("时长转换成秒区间段时,传入参数格式错误,允许的格式为非负数");
        return "格式错误";
      }
      seconds = Number(secResult);
    }

    if (seconds >= 0 && seconds < unit) {
      section = `0~1分钟`;
    } else if (seconds >= unit && seconds < unit * 2) {
      section = `1~2分钟`;
    } else if (seconds >= unit * 2 && seconds < unit * 3) {
      section = `2~3分钟`;
    } else if (seconds >= unit * 3 && seconds < unit * 4) {
      section = `3~4分钟`;
    } else if (seconds >= unit * 4 && seconds < unit * 5) {
      section = `4~5分钟`;
    } else if (seconds >= unit * 5) {
      section = `5分钟以上`;
    } else if (seconds < 0) {
      return "格式错误";
    }

    console.log(`传入时长：${duration}，输出时长区间段（单位:分钟）：`, section);
    return section;
  }

  /**
   * 时间秒数格式化
   * @param seconds 时间（单位：秒）
   * @returns {*} 格式化后的时分秒
   */
  static secToTime(seconds: number): string {
    const hour = Math.floor(seconds / 60 / 60);
    const min = Math.floor((seconds / 60) % 60);
    const sec = Math.floor(seconds % 60);
    if (hour === 0) {
      return [min, sec].join(":").replace(/\b(\d)\b/g, "0$1");
    }
    return [hour, min, sec].join(":").replace(/\b(\d)\b/g, "0$1");
  }
}

export default DateHelper;
